__webpack_require__.p = "/reports-pie-chart-preset-1/onboarding/";